import React from 'react';
import PropTypes from 'prop-types';
import { tagQueries } from '../../graphql/queries';
import BBQuery from './BBQuery.js';

// uses render props pattern - https://reactjs.org/docs/render-props.html
// in this case prop is 'children' not 'render' but its the same concept

class TagGroups extends React.Component {
  render () {
    const { children } = this.props;
    return (
      <BBQuery query={tagQueries.TagGroups}>
        {data => {
          return children(data.tagGroups);
        }}
      </BBQuery>
    );
  }
}

TagGroups.propTypes = {
  children: PropTypes.func.isRequired
};

export default TagGroups;
